import { useEffect, useState } from "react";
import { useId } from "react-aria";
import { Control, Controller } from "react-hook-form";
import { Checkbox, Label, TextArea } from "semantic-ui-react";
import { errorMessageSelector } from "../../../../../data-filters/components/Utils";

export function ControlledTextAreaToggle({
  control,
  name,
  label,
  placeholder,
  required,
  rows,
  errors,
  overrideToggle,
  onToggle = () => {},
}: {
  control: Control;
  name: string;
  label: string;
  placeholder?: string;
  required?: boolean;
  rows?: number;
  errors?: any;
  overrideToggle?: boolean;
  onToggle?: (show: boolean) => void;
}) {
  return (
    <Controller
      rules={{ ...(required ? { required: "This field is required" } : {}) }}
      control={control}
      name={name}
      render={({ value, onChange }) => {
        const [showInput, setShowInput] = useState(!!value);

        const id = useId();

        useEffect(() => {
          if (value) {
            setShowInput(true);
          }
        }, [value, setShowInput]);

        const error = errorMessageSelector(errors)(name);

        const finalShowInput = overrideToggle !== undefined ? overrideToggle : showInput;

        useEffect(() => {
          if (!finalShowInput) {
            onChange(null);
          }
        }, [finalShowInput]);

        return (
          <div className='tw-space-y-2'>
            <Checkbox
              label={label}
              checked={finalShowInput}
              onChange={() => {
                setShowInput((prev) => !prev);
                onToggle(!finalShowInput);
              }}
              toggle
            />
            {finalShowInput && (
              <>
                <TextArea
                  id={id}
                  name={name}
                  value={value ?? ""}
                  onChange={(date) => {
                    setShowInput(true);
                    onChange(date);
                  }}
                  placeholder={placeholder}
                  rows={rows}
                />
                {error && (
                  <Label basic prompt pointing='above' aria-live='polite' id={`${name}-error`}>
                    {error}
                  </Label>
                )}
              </>
            )}
          </div>
        );
      }}
    />
  );
}
